import React, { FC } from 'react';
import { Icon } from './Icon';

interface FrontPaginationProps {
  page: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
  onNumClick: (num: number) => void;
}

export const FrontPagination: FC<FrontPaginationProps> = ({
  page,
  totalPages,
  onNext,
  onPrevious,
  onNumClick,
}) => {
  return (
    <div className="flex justify-between pt-8">
      <div className="flex space-x-2 pt-4" onClick={onPrevious}>
        <Icon.ArrowLeft />
        <p className="hidden md:flex">이전</p>
      </div>

      <div className="grid grid-cols-7 gap-4 text-center">
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(
          (item, index) => {
            if (item > page + 4 || item < page - 2) return null;
            if (item === page + 1) {
              return (
                <div
                  className="wh-10 grid place-content-center relative mx-4"
                  key={index}
                  onClick={() => onNumClick(item)}>
                  <div className="absolute h-0.5 w-full bg-gray-900 -bottom-1" />
                  <p className="pt-4">{item}</p>
                </div>
              );
            } else {
              return (
                <p
                  className="text-gray-500 wh-10 grid place-items-end justify-center"
                  key={index}
                  onClick={() => onNumClick(item)}>
                  {item}
                </p>
              );
            }
          },
        )}
      </div>

      <div className="flex space-x-2 pt-4" onClick={onNext}>
        <p className="hidden md:flex">다음</p>
        <Icon.ArrowRight />
      </div>
    </div>
  );
};
